import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { renderWithLinks } from '../../../utils/renderWithLinks';

export interface HelpModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  infoText?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const HelpModal: React.FC<HelpModalProps> = ({
  open,
  onClose,
  title = 'Help',
  infoText = '',
  maxWidth = 'sm',
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={maxWidth}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
        <Typography variant="h6" component="div">
          {title}
        </Typography>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box>
          {renderWithLinks(infoText)}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default HelpModal;
